import { selectCurrentHotelId } from 'accessors'
import { useSelector } from 'react-redux'

import { getHeaderPlanDisplayInfo } from './hotelPlanDisplayName'
import { getAvailableSolutionFeatures } from './hotelSolutionFeatures'

export function useHotelPlanInfo(subscriptionsOverride = null) {
  const activeServices = useSelector(s => s.hotelDetails.activeServices)
  const isSiteAbandonmentMenuVisible = useSelector(
    s => s.hotelDetails.isSiteAbandonmentMenuVisible
  )
  const subsidiaryId = useSelector(selectCurrentHotelId)
  const subscriptionsFromStore = useSelector(
    s => s.hotelDetails.otherSubsidiaries?.[subsidiaryId]?.subscriptions || []
  )
  const subscriptions = subscriptionsOverride ?? subscriptionsFromStore

  const planInfo = getHeaderPlanDisplayInfo({
    subscriptions,
    activeServices,
    isSiteAbandonmentMenuVisible
  })

  if (!planInfo.shouldShow || !planInfo.displayName) {
    return { planInfo, solutionFeatures: null, shouldShow: false }
  }

  const solutionFeatures = getAvailableSolutionFeatures({
    tier: planInfo.tier,
    hasEmailDrip: planInfo.hasEmailDrip,
    hasCartAbandonment: planInfo.hasCartAbandonment
  })

  if (!solutionFeatures.planLabel || !solutionFeatures.sections.length) {
    return { planInfo, solutionFeatures: null, shouldShow: false }
  }

  return { planInfo, solutionFeatures, shouldShow: true }
}
